import PropTypes from 'prop-types'
import classNames from 'classnames'

import { useBreakpoints } from '@saatva-bits/pattern-library.hooks.use-breakpoints'
import { SimpleSlider } from '@saatva-bits/pattern-library.components.simple-slider'

import PictureImgix from '@/components/PictureImgix'
import { AffirmLogo } from '../../svgs'

import styles from './AccountFlow.module.scss'

const AffirmSlide = ({ title, subtitle, step }) => {
    const accountFlowStep = `account-flow-${step}`

    return (
        <div className={styles.slide}>
            <div className={styles.slideTextContainer}>
                <div className={classNames('t-heading3 t-black u-marginBottom--sm', styles.slideTitle)}>
                    {title}
                </div>
                <div className={classNames('t-heading4 t-black', styles.slideSubtitle)}>
                    {subtitle}
                </div>
            </div>
            <PictureImgix
                folder={`financing/account-flow/${accountFlowStep}`}
                name={`${accountFlowStep}.png`}
                alt={accountFlowStep}
                isUniversal={true}
                imageClassName={styles.slideImage}
                widths={{
                    mobile: 756,
                    tablet: 756,
                    desktop: 756
                }}
            />
        </div>
    )
}

AffirmSlide.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    step: PropTypes.string
}

const AccountFlow = () => {
    const { isMobile } = useBreakpoints('mobile')

    const slides = [
        {
            title: '1. Fill your cart',
            subtitle: 'Select Affirm at checkout, then enter a few pieces of info for a real-time decision.',
            step: 'step-1'
        },
        {
            title: '2. Choose how you pay',
            subtitle: 'Pick the monthly payment plan you like best. You\'ll never pay more than you agree to up front.',
            step: 'step-2'
        },
        {
            title: '3. Pay over time',
            subtitle: 'Make payments at affirm.com or in the Affirm app. You\'ll get email and text reminders.',
            step: 'step-3'
        }
    ]

    return (
        <section className={classNames('u-bgColor--contrast1 u-paddingVertical--4xl', styles.container)}>
            <h2 className="t-heading2">Buying with Affirm is simple</h2>
            <div className="u-hidden--lg-up u-marginBottom--2xl">
                <SimpleSlider
                    peekable
                    dotLines
                    pageDots
                    initialIndex={0}
                    infinite={false}
                    showButtons={false}
                    sliderLabel="affirmTile"
                    shownSize={isMobile ? 1 : 2}
                    sliderClassName={styles.slider}
                    dotClassName={styles.sliderDot}
                    childClass={styles.sliderSlide}
                >
                    {slides.map((slide, index) => {
                        return (
                            <AffirmSlide
                                key={`${index}_${slide.title}`}
                                {...slide}
                            />
                        )
                    })}
                </SimpleSlider>
            </div>
            <div className="u-hidden--lg-down u-marginBottom--2xl">
                <div className="container">
                    <div className="row row--center-xs">
                        <div className="col col--xs-12 u-flexDisplay u-flexDirection--row">
                            {slides.map((slide, index) => {
                                return (
                                    <AffirmSlide
                                        key={`${index}_${slide.title}`}
                                        {...slide}
                                    />
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row row--center-xs">
                    <div className={styles.banner}>
                        {'Just select at '}
                        <AffirmLogo size="sm" />
                        {' checkout'}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AccountFlow
